import { css } from "@emotion/css";
import { Button, Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import { formatUrl } from "~/components/Navigation/ExternalLink/ExternalLink";
import useLocalStorage from "~/hooks/useLocalStorage";
import { useOctopusFeatureToggle } from "~/hooks/useOctopusFeatureToggle";
export function ArgoCDFeedbackCallout() {
    const maxSnoozeCount = 5;
    const [snoozeUntil, setSnoozeUntil] = useLocalStorage("Octopus.ArgoCallout.SnoozeUntil", new Date(0));
    const [snoozeCount, setSnoozeCount] = useLocalStorage("Octopus.ArgoCallout.SnoozeCount", 0);
    const calloutFeatureEnabled = useOctopusFeatureToggle("argocd-feedback-callout", false);
    if (!calloutFeatureEnabled)
        return;
    if (snoozeCount >= maxSnoozeCount)
        return;
    if (new Date() < new Date(snoozeUntil))
        return;
    const snoozeForDays = (daysToSnooze: number) => {
        const newSnoozeUntil = new Date();
        newSnoozeUntil.setDate(newSnoozeUntil.getDate() + daysToSnooze);
        setSnoozeUntil(newSnoozeUntil);
    };
    const onClickFeedback = () => {
        window.open(formatUrl("argo-feedback"), "_blank");
        snoozeForDays(30);
    };
    const onClickSnooze = () => {
        snoozeForDays(2);
        setSnoozeCount(snoozeCount + 1);
    };
    return (<Callout title="Help us improve Argo CD in Octopus" type="new-feature">
            Tell us how this feature worked for you, or report any problems you noticed
            <div className={actionsContainerStyles}>
                <Button importance="loud" label={"Share Feedback"} onClick={onClickFeedback}/>
                <Button importance={"quiet"} label={"Ask Me Later"} onClick={onClickSnooze}/>
            </div>
        </Callout>);
}
const actionsContainerStyles = css({
    display: "flex",
    alignItems: "center",
    alignContent: "center",
    flexWrap: "wrap",
    gap: space[16],
    paddingTop: space[12],
});
